import { CardContent } from './Card'
import { CardLoadingPlaceholder } from './CardLoadingPlaceholder'

const LoadingPlaceholderCardContent = () => {
    return (
      <CardContent
        className='card-content'
      >
          <CardLoadingPlaceholder />
      </CardContent>
    )
}

export { LoadingPlaceholderCardContent }
